import { useTranslation } from 'react-i18next';
import { Modal } from '@heroui/react';
import { Button } from '@/components/Button';

/**
 * «Не сохранять изменения?» — asked before a close/back/section switch would
 * throw away an edit the user hasn't saved. Esc or the backdrop keeps editing;
 * only the explicit button discards.
 */
export function DiscardChangesDialog(props: {
  open: boolean;
  onDiscard: () => void;
  onKeep: () => void;
}) {
  const { t } = useTranslation();
  return (
    <Modal.Backdrop isOpen={props.open} onOpenChange={(open) => !open && props.onKeep()}>
      <Modal.Container size="sm">
        <Modal.Dialog role="alertdialog">
          <Modal.Header>
            <Modal.Heading>{t('common.unsaved.title')}</Modal.Heading>
          </Modal.Header>
          <Modal.Body>
            <p className="text-sm text-ink-muted">{t('common.unsaved.body')}</p>
            <div className="mt-5 flex justify-end gap-2">
              <Button variant="ghost" className="min-h-11" onClick={props.onKeep} autoFocus>
                {t('common.unsaved.keep')}
              </Button>
              <Button variant="danger" className="min-h-11" onClick={props.onDiscard}>
                {t('common.unsaved.discard')}
              </Button>
            </div>
          </Modal.Body>
        </Modal.Dialog>
      </Modal.Container>
    </Modal.Backdrop>
  );
}
